import { useEffect, useRef } from "react";

/**
 * Hook to handle cleanup on unmount
 */
export const useCleanupOnUnmount = (
  isShowCalendar: boolean | undefined,
  onChangeData: () => void
) => {
  const isShowCalendarRef = useRef(isShowCalendar);
  const onChangeDataRef = useRef(onChangeData);

  // Keep refs up to date
  isShowCalendarRef.current = isShowCalendar;
  onChangeDataRef.current = onChangeData;

  useEffect(() => {
    // Only run cleanup on unmount, not when dependencies change
    return () => {
      if (isShowCalendarRef.current) {
        onChangeDataRef.current();
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Empty dependency array - only run on mount/unmount
};
